import { Box, Card, CardHeader, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';

export type SectionContainerProps = {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
};

export const SectionContainer: React.FC<SectionContainerProps> = ({ title, action, children }) => {
  const { classes } = useStyles();

  return (
    <Card variant="outlined">
      <CardHeader
        className={classes.header}
        title={title}
        action={action}
        slotProps={{
          title: { variant: 'h5', className: classes.headerTitle }
        }}
      />
      {children}
    </Card>
  );
};

export type SectionContainerContentProps = {
  className?: string;
} & Pick<SectionContainerProps, 'children'>;

export const SectionContainerContent: React.FC<SectionContainerContentProps> = ({ children, className }) => {
  const { classes, cx } = useStyles();

  return <Box className={cx([ classes.cardContent, className ])}>{children}</Box>;
};

export const SectionContainerDivider: React.VFC = () => {
  return (
    <Box pt={.5} pb={.5}>
      <Divider />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  header: {
    padding: theme.spacing(2, 3),
    boxShadow: `inset 0 -1px 0 ${grey[300]}`
  },
  headerTitle: {
    fontWeight: 450,
    fontSize: '20px'
  },
  cardContent: {
    padding: theme.spacing(3)
  }
}));
